// Only one item MUST have the "default: true" key

module.exports = {
  bg: {
    default: true,
    path: `bg`,
    locale: `bg-BG`,
    dateFormat: `DD.MM.YYYY`,
    siteLanguage: `bg`,
    ogLanguage: `bg_BG`,
    defaultTitle: `BG Live`,
    defaultDescription: `BG Live streaming platform`,
  },
  en: {
    path: `en`,
    locale: `en-US`,
    dateFormat: `DD/MM/YYYY`,
    siteLanguage: `en`,
    ogLanguage: `en_US`,
    defaultTitle: `BG Live`,
    defaultDescription: `BG Live streaming platform`,
  },
}
